$(document).ready(function () {
  function hideSwiperDuplicates(containerSelector) {
    var duplicateSlides = $(containerSelector).find(".swiper-slide-duplicate");
    duplicateSlides.attr("aria-hidden", "true");
    duplicateSlides
      .find("a, button, input, select, textarea, [tabindex]")
      .attr("tabindex", "-1");
    duplicateSlides.find("[id]").removeAttr("id");
  }

  function isTouchSupported() {
    var msTouchEnabled = window.navigator.msMaxTouchPoints;
    var generalTouchEnabled = "ontouchstart" in document.createElement("div");
    if (msTouchEnabled || generalTouchEnabled) {
      return true;
    }
    return false;
  }

  $.autofilter({});

  // product slider
  if ($(".product-page-wrapper").length > 0) {
    var swiper = new Swiper(".product-thumbnail", {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    });
    var swiper2 = new Swiper(".product-images", {
      spaceBetween: 0,
      thumbs: {
        swiper: swiper,
      },
    });
    hideSwiperDuplicates(".product-thumbnail");

    if (typeof $.fn.zoom === "function") {
      $(".product-images .swiper-slide").zoom();
    }
  }

  if ($(".our-projects").length > 0) {
    var swiper = new Swiper(".our-projects .swiper-container", {
      slidesPerView: 3,
      spaceBetween: 10,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },

      speed: 1500,
      // pagination
      pagination: ".swiper-pagination",
      paginationClickable: true,

      navigation: {
        nextEl: "#js-next1",
        prevEl: "#js-prev1",
      },

      breakpoints: {
        580: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        740: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        980: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },
    });
    hideSwiperDuplicates(".our-projects .swiper-container");
  }

  if ($(".home-banner:not(.hybrid)").length > 0) {
    var swiper = new Swiper(".home-banner .swiper-container", {
      spaceBetween: 30,
      centeredSlides: true,
      speed: 2000,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    hideSwiperDuplicates(".home-banner .swiper-container");
  }

  if ($(".faq").length > 0) {
    $(".faq h6").on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
      } else {
        $(".faq h6").removeClass("active");
        $(this).addClass("active");
      }
    });
  }

  $(".project-list .col").each(function () {
    lc_lightbox($("#" + $(this).attr("id") + " a"));
  });

  /*-----------------
    portfolio slider
    -----------------*/

  if (isTouchSupported()) {
    // you can change class name mobile to your choise
    $("body").addClass("mobile");
    // write code here for toouch screen
  }

  $(".toTop").on("click", function (e) {
    event.preventDefault();
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      1000
    );
  });

  /*-----------------
    mobile-trigger
    -----------------*/
  $(".mobile-trigger a").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $("body").removeClass("showNav");
      $("body").removeClass("show-quote");
    } else {
      $(this).addClass("active");
      $("body").addClass("showNav");
    }
  });
  $(window).resize(function () {
    if ($(window).width() > 740) {
      $("body").removeClass("showNav");
      $(".mobile-trigger a").removeClass("active");
    }
  });

  // my account
  $(".ico-account-wrapper").on("mouseenter", function () {
    if ($(window).width() > 560) {
      $(this).addClass("active");
    }
  });
  $(".ico-account-wrapper").on("mouseleave", function () {
    if ($(window).width() > 560) {
      $(this).removeClass("active");
    }
  });

  $(".ico-account-wrapper").on("click", function (e) {
    if ($(window).width() < 561) {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
      } else {
        $(this).addClass("active");
      }
    }
  });

  /*-----------------
    navigation
    -----------------*/
  $(".menu-block  ul.main-menu >  li").each(function (i) {
    if ($("ul", this).length > 0) {
      $(this).addClass("has-submenu");
    } else {
      $(this).addClass("no-submenu");
    }
  });

  $(".menu-block  ul.main-menu >li").on("mouseenter", function () {
    if ($(window).width() > 1140 && $("ul", this).length > 0) {
      $(this).addClass("active");
    }
  });
  $(".menu-block ul.main-menu >li").on("mouseleave", function () {
    if ($(window).width() > 1140 && $("ul", this).length > 0) {
      $(this).removeClass("active");
    }
  });
  $(".menu-block  ul >li").on("click", function (e) {
    if ($(window).width() < 1141 && $("ul", this).length > 0) {
      if ($(this).hasClass("active")) {
        $(".menu-block  ul >li").removeClass("active");
      } else {
        $(".menu-block  ul >li").removeClass("active");
        $(this).addClass("active");
      }
    }
  });
  $(".menu-block  ul >li >a ").on("click", function (e) {
    if ($(window).width() < 1141) {
      e.stopPropagation();
    }
  });

  if($('#paypal-express-checkout-btn').length){
    var payButt = document.getElementById('paypal-express-checkout-btn');
    payButt.remove();
  }

  $('.new_filter a').click(function(evt){
    evt.preventDefault();
    var tab_id = $(this).attr('data-tab');

    $('.new_filter li').removeClass('active');
    $('.tab-contents').removeClass('active');

    $(this).closest('li').addClass('active');
    $("#"+tab_id).addClass('active');
  });
  
});

$(document).click(function () {
  var container = $(".ico-account-wrapper");
  if (!container.is(event.target) && !container.has(event.target).length) {
    container.removeClass("active");
  }
});
